import React, { useState, useEffect, useContext, useMemo } from "react";
import { Redirect, Link } from "react-router-dom";

import ActionPlansContext from "context/ActionPlansContext";
import _ from "lodash";
import moment from "moment";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { statusData, criticityData  } from "variables/lists/action";
import UploadActionDialog from "./UploadActionDialog";
import FilterData from "./FilterData";
import UserService from "services/UserService";
import AdvancedSearchContext from "context/AdvancedSearchContext";
//import useActionTable from "../useActionTable.js";

const FilterButton = styled.div`
  margin-right: 15px;
  &:hover {
    cursor: pointer;
  }
`;

const UploadButton = styled.div`
  margin-left: 15px;
  &:hover {
    cursor: pointer;
  }
`;

const TableName = styled.h1`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

export default function useActionTable() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplancreate = permis.includes("actionplan_create");
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById, setPage } = advancedSearchContext;
  // Though this is a GET, use a POST & method override because the sorted and
  // filtered params are complex (arrays of objects) for easier parsing.
  const [totalRows, setTotalRows] = useState(0);
  const [results, setResults] = useState();
  const [isRefetched, setIsRefetched] = useState(false);


  const appContext = useContext(ActionPlansContext);
  const { actionPlans } = appContext;

  const refreshTable = () => {
    setIsRefetched(!isRefetched);
  };

  useEffect(() => {
    setResults(actionPlans);
  }, [isRefetched, actionPlans]);

 
 // console.log(results);

  // ----------------------------------------------------------

  const [filterText, setFilterText] = useState("");
  const [filterId, setFilterId] = useState("Text");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const FilterComponent = ({ onUpload }) => (
    <>
      <FilterButton type="button" onClick={onUpload}>
        {/*<PublishIcon fontSize="default" />
        <UploadText>Import</UploadText>*/}
        <FilterData />
      </FilterButton>
    </>
  );

  const UploadComponent = ({ onUpload }) => (
    <UploadButton type="button" onClick={onUpload}>
      <UploadActionDialog
        onClick={onUpload}
        refetch={refreshTable}
      //setLoading={setLoading}
      />
    </UploadButton>
  );

  const [openModal, setOpenModal] = useState(false);
  const handleClickOpen = () => {
    setOpenModal(true);
  };
  const handleClose = () => {
    setOpenModal(false);
  };

  const actions_dashboard = _.get(results, `actions_dashboard`, []);

  const filteredItems = _.get(results, "actions", []).filter(
    (item) =>
       (item.parameters.status && statusData.find((x) => x.id == item.parameters.status) && statusData.find((x) => x.id == item.parameters.status).name.toLowerCase().includes(filterText.toLowerCase())) ||
       (item.parameters.criticity && criticityData.find((x) => x.id == item.parameters.criticity) && criticityData.find((x) => x.id == item.parameters.criticity).name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.name && typeof item.parameters.name == 'string' && item.parameters.name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.groups && groupInfoListById["" + item.parameters.groups] && groupInfoListById["" + item.parameters.groups].toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.wantedenddate && moment(item.parameters.wantedenddate).isValid() && moment(item.parameters.wantedenddate).format("DD/MM/YYYY").includes(filterText)) ||
      (item.parameters.lastupdate && moment(item.parameters.lastupdate).isValid() && moment(item.parameters.lastupdate).format("DD/MM/YYYY").includes(filterText)) ||
      (item.parameters.wantedstartdate && moment(item.parameters.wantedstartdate).isValid() && moment(item.parameters.wantedstartdate).format("DD/MM/YYYY").includes(filterText))
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    const onFilterText = (e) => setFilterText(e.target.value);

    return (
      <>
        <TableName>Gestion des actions</TableName>
        {/* <FilterComponent key="UploadComponent" onUpload={handleClear} /> */}
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {actionplancreate && (
          <UploadComponent key="UploadComponent" onUpload={handleClear} />
        )}
      </>
    );
  }, [filterText, resetPaginationToggle]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      //onChangeRowsPerPage: handlePerRowsChange,
      //onChangePage: handlePageChange,
      //onSort: handleSort,
    },
    actions_dashboard,
    refreshTable,
  };
}
